export const DOCUMENT_TYPE_ADDENDUM = "ADDENDUM";
export const DOCUMENT_TYPE_CONTRACT = "CONTRACT";
